import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Layout, Shield, Zap, BookOpen, Wrench } from 'lucide-react';
import { CTA } from './ui/Button';
export function HeroSection() {
  return <section className="relative pt-6 pb-20 overflow-hidden" data-id="element-54">
      {/* Decorative blobs */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-5xl h-[500px] bg-purple-200/30 blur-[100px] rounded-full pointer-events-none" data-id="element-55" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-56">
        {/* Top Bar */}
        <div className="flex justify-center mb-12" data-id="element-57">
          <span className="text-teal-600 font-bold tracking-[0.2em] text-sm uppercase flex items-center gap-2" data-id="element-58">
            ⭐ Aula Mater ⭐
          </span>
        </div>

        {/* Hero Content — stacked */}
        <div className="max-w-4xl mx-auto text-center mb-12" data-id="element-59">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-60">
            <h1 className="font-serif text-4xl sm:text-5xl lg:text-7xl font-bold text-navy-900 leading-[1.1] tracking-tight mb-6 uppercase" data-id="element-61">
              Megapack —<br data-id="element-62" />
              <span className="text-violet-700" data-id="element-63">Psicopedagogía Clínica</span>
            </h1>

            <p className="text-lg sm:text-xl text-slate-600 mb-6 max-w-2xl mx-auto" data-id="element-64">
              Todo lo que necesitás para fortalecer tu práctica clínica
              psicopedagógica.
            </p>

            <p className="font-serif italic text-xl sm:text-2xl text-teal-600" data-id="element-65">
              Claridad · Organización · Seguridad profesional
            </p>
          </motion.div>
        </div>

        {/* Hero Image — below tagline, centered */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative max-w-3xl mx-auto mb-12" data-id="element-66">
          <div className="absolute inset-0 bg-gradient-to-tr from-violet-100 to-teal-50 rounded-3xl transform rotate-2 scale-[1.03] -z-10" data-id="element-67" />
          <img src="https://cdn.magicpatterns.com/uploads/3sM8T9ddePiXgUqHZe5gWB/ad2.png" alt="Megapack Psicopedagogía Clínica — Aula Mater" className="w-full h-auto rounded-2xl shadow-2xl border border-white/50" data-id="element-68" />
        </motion.div>

        {/* Badges + CTA */}
        <div className="max-w-4xl mx-auto text-center mb-20" data-id="element-69">
          <div className="flex flex-wrap justify-center gap-3 mb-10 text-sm font-medium text-slate-600" data-id="element-70">
            <span className="flex items-center gap-1.5 bg-white/60 px-3 py-1.5 rounded-full border border-slate-200/60" data-id="element-71">
              <CheckCircle2 className="w-4 h-4 text-teal-500" data-id="element-72" /> 100% PDF
            </span>
            <span className="flex items-center gap-1.5 bg-white/60 px-3 py-1.5 rounded-full border border-slate-200/60" data-id="element-73">
              <CheckCircle2 className="w-4 h-4 text-teal-500" data-id="element-74" /> Acceso
              inmediato
            </span>
            <span className="flex items-center gap-1.5 bg-white/60 px-3 py-1.5 rounded-full border border-slate-200/60" data-id="element-75">
              <CheckCircle2 className="w-4 h-4 text-teal-500" data-id="element-76" /> Material
              editable
            </span>
            <span className="flex items-center gap-1.5 bg-white/60 px-3 py-1.5 rounded-full border border-slate-200/60" data-id="element-77">
              <CheckCircle2 className="w-4 h-4 text-teal-500" data-id="element-78" /> Hecho en
              Argentina
            </span>
          </div>

          <CTA data-id="element-79" />

          <p className="mt-6 text-sm text-slate-500 font-medium" data-id="element-80">
            +2.000 profesionales • 8 módulos • Kit PPI • Kit de herramientas
            profesionales
          </p>
        </div>

        {/* Benefits Strip */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 max-w-6xl mx-auto" data-id="element-81">
          {[{
          icon: Zap,
          text: 'Más claridad clínica'
        }, {
          icon: Layout,
          text: 'Más organización'
        }, {
          icon: Shield,
          text: 'Más seguridad profesional'
        }, {
          icon: CheckCircle2,
          text: 'Menos improvisación'
        }, {
          icon: BookOpen,
          text: 'Más estructura profesional'
        }, {
          icon: Wrench,
          text: 'Más herramientas reales'
        }].map((benefit, i) => <div key={i} className="bg-white rounded-xl p-4 shadow-sm border border-slate-100 flex flex-col items-center text-center gap-3 hover:shadow-md transition-shadow" data-id="element-82">
              <div className="w-10 h-10 rounded-full bg-teal-50 flex items-center justify-center text-teal-600" data-id="element-83">
                <benefit.icon className="w-5 h-5" data-id="element-84" />
              </div>
              <span className="text-sm font-semibold text-navy-900 leading-tight" data-id="element-85">
                {benefit.text}
              </span>
            </div>)}
        </motion.div>
      </div>
    </section>;
}